// extracted by mini-css-extract-plugin
export default {"depositGuaranteeSidebar":"l5wKuTRqW6ZHEXMgGqTf","depositGuaranteeTip":"A1RjdOtrM3MSMcipsMlO"};